export var NotificationWayType;
(function (NotificationWayType) {
    NotificationWayType["USERS_OF_AGENT"] = "users_of_agent";
    NotificationWayType["USERS_ACCOUNTS"] = "user_accounts";
    NotificationWayType["ALL"] = "all";
})(NotificationWayType || (NotificationWayType = {}));
//# sourceMappingURL=NotificationWayType.js.map